import axios from 'axios';
import Home from './main-views/Home';
import AboutUs from './main-views/AboutUs';
import ContactUs from './main-views/ContactUs';
import Services from './main-views/Services';
import News from './main-views/News';
import Gallery from './main-views/Gallery';
import Policies from './main-views/Policies';
import Portfolio from './ones/Portfolio';
import Products from './ones/Products';
import Staff from './ones/Staff';
import Testimonials from './ones/Testimonials';
import AppDevLanding from "./views/AppDevLanding";
import WebDev from './views/services/WebDev';
import Tax from './views/services/Tax';
import Websites from "./views/services/Websites";
import ViewPolicy from "./views/ViewPolicy";
import ViewNews from "./views/ViewNews";
import ViewGallery from "./views/ViewGallery";
import ViewSoldrax from "./views/ViewSoldrax";
import ViewProduct from "./views/ViewProduct";
import ViewPortfolio from "./views/ViewPortfolio";
import ViewAfya from "./views/ViewAfya";
import SDL from "./views/SDL";
import VAT from "./views/VAT";
import PAYEE from "./views/PAYEE";
import NSSF from "./views/NSSF";
import WCF from "./views/WCF";
import FILING from "./views/FILING";
import RECEIPT from "./views/RECEIPT";
import RESOLUTION from "./views/RESOLUTION";
import Career from './main-views/Careers';
import JobOptions from './views/JobOptions';
import MyApplication from './views/MyApplication';
import CreateApplication from './views/CreateApplication';
import EditApplicantProfile from './views/EditApplicantProfile';


export const BASE_API = 'https://webapi.werenium.com/api/';

export const CDN_URL = 'https://v2.werenium.com/cdn/';


export function getMainView(app) {
  if (app.navItem === 'home') {
    return <Home />
  } else if (app.navItem === 'about_us') {
    return <AboutUs />
  } else if (app.navItem === 'contact_us') {
    return <ContactUs />
  } else if (app.navItem === 'services') {
    return <Services />
  } else if (app.navItem === 'portfolio') {
    return <Portfolio />
  } else if (app.navItem === 'gallery') {
    return <Gallery />
  } else if (app.navItem === 'news') {
    return <News />
  } else if (app.navItem === 'products') {
    return <Products />
  } else if (app.navItem === 'team') {
    return <Staff />
  } else if (app.navItem === 'testimonials') {
    return <Testimonials />
  } else if (app.navItem === 'policies') {
    return <Policies />
  } else if (app.navItem === 'careers') {
    return <Career />
  } else {
    //default home
    return <Home />
  }

  return null;
}


export function getViewerView(app) {
  
  if (
    app.navItem === 'view' &&
    app.navSubItem === 'software' &&
    (
      app.navExtraItem === 'webDev' ||
      app.navExtraItem === 'WebDev'
    ) &&
    !app.navMoreItem
  ) {
    return <WebDev />;
  } else if (
    app.navItem === 'view' &&
    app.navSubItem === 'software' &&
    (
      app.navExtraItem === 'appDev' ||
      app.navExtraItem === 'AppDev'
    ) &&
    !app.navMoreItem
  ) {
    return <AppDevLanding />;
  } else if (
    app.navItem === 'view' &&
    app.navSubItem === 'websites' &&
    !app.navExtraItem
  ) {
    return <Websites />;
  } else if (
    app.navItem === 'view' &&
    app.navSubItem === 'policy'
  ) {
    return <ViewPolicy uuid={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'gallery' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewGallery uuid={app.navExtraItem} />
    )
  } else if (
    app.navSubItem === 'SDL' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <SDL />
    )
  } else if (
    app.navSubItem === 'VAT' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <VAT />
    )
  } else if (
    app.navSubItem === 'PAYE' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <PAYEE />
    )
  } else if (
    app.navSubItem === 'NSSF' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <NSSF />
    )
  } else if (
    app.navSubItem === 'WCF' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <WCF />
    )
  } else if (
    app.navSubItem === 'RESOLUTION' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <RESOLUTION />
    )
  } else if (
    app.navSubItem === 'RECEIPT' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <RECEIPT />
    )
  } else if (
    app.navSubItem === 'FILING' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <FILING />
    )
  } else if(
    app.navSubItem === 'news' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewNews uuid={app.navExtraItem} />
    )
  } else if(
    app.navSubItem === 'soldrax' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewSoldrax/>
    )
  } else if(
    app.navSubItem === 'afya' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewAfya/>
    )
  } else if(
    app.navSubItem === 'product' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewProduct uuid={app.navExtraItem}/>
    )
  } else if(
    app.navSubItem === 'portfolio' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewPortfolio uuid={app.navExtraItem}/>
    )
  } 

  return null;
}

export function getSideViewerView(app) {
  if(
    app.navSubItem === 'job-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <JobOptions uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'create-application' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <CreateApplication uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'my-applications' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <MyApplication uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'edit-applicant-profile' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <EditApplicantProfile uuid={app.navExtraItem}/>
  } 

  return null;
}


export function getInlineLoader() {
  return (
    <div className="Loader"></div>
  )
}


export const testimonials = [
  {
    id: 1,
    message:
      "Transitioning to digital VAT e-filing has eliminated manual errors and reduced submission time dramatically. The platform provides real-time validation, ensuring every return meets regulatory standards before submission.",
    name: "ALFRED",
    title: "MANAGING DIRECTOR",
    organization: "FAGECO Co. LTD"
  },
  {
    id: 2,
    message:
      "Our finance team used to struggle with scattered documents and compliance deadlines. With automated reminders and centralized digital records, we now file all VAT returns on time with complete confidence.",
    name: "Beatrice Mhando",
    title: "CEO",
    organization: "Tech Innovate Ltd"
  },
  {
    id: 3,
    message:
      "The e-filing workflow has streamlined our audit process. Instant access to historical returns, secure digital receipts, and automated tax computations have transformed how we manage VAT obligations.",
    name: "Edwin Kalua",
    title: "FINANCE MANAGER",
    organization: "Prime Agro Solutions"
  }
];


export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      // .. setup form data
      let formData = new FormData();
      formData.append('language', getCookie('language'));

      for (let key in params) {
        formData.append(key, params[key]);
      }

      for (let key in user) {
        formData.append(key, user[key]);
      }

      // Retry mechanism: try up to 3 times
      let attempt = 0;
      const maxRetries = 3;

      const makeRequest = async () => {
        try {
          const response = await axios.post(BASE_API + url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          console.log(url, response.data);
          resolve(response.data); // Successfully resolve with response data
        } catch (error) {
          attempt++;
          if (attempt < maxRetries) {
            console.log(`Attempt ${attempt} failed. Retrying...`);
            makeRequest(); // Retry the request
          } else {
            resolve({
              status: 0,
              msg: "Network Connection Error after 3 attempts",
            }); // Resolve after 3 failed attempts
          }
        }
      };

      // Start the request attempts
      makeRequest();
    });
  });
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userUuid = getCookie('userUuid');
    let userToken = getCookie('userToken');
    let userType = getCookie('useType');

    resolve({
      userUuid,
      userToken,
      userType,
    })


  })
}

export function setCookie(cname, cvalue, exdays) {
  cname = 'werenium-admin-'+cname;
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  cname = 'werenium-admin-'+cname;
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function formatMoney(x) {
  //round x to 2 decimal places before og function
  x = Number(x);
  x = x.toFixed(0);

  //then continue
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if (num <= 1 && num >= -1) {
    return num;
  }

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return Math.abs(num) >= item.value; // Use absolute value of num
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function stringToArray(string) {
  const array = string.split(",").map(item => item.trim());
  return array;
}

export function arrayToString(arr) {
  return arr.join(', ');
}

export function getCurrentYear() {
  return new Date().getFullYear();
}
